import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box } from '@mui/material';
import { CustomCheckbox } from './../../../../components/CustomCheckbox';



/**
 * @Author: Susana García Rodriguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.m
 *
 * @param {Object} props
 * @param {Array} props.columns [{ key, label, icon }]
 * @param {Array} props.rows [{ id, label, values }]
 * @param {Function} props.onChange
 * @param {Function} props.t (i18n function)
 * @param {boolean} [props.disabled]
 */
const BorderTopTable = ({ columns = [], rows = [], onChange, t, disabled = false }) => {
    const handleChange = (rowId, columnKey) => (e) => {
        onChange?.(e, rowId, columnKey);
    };

    return (
        <TableContainer className="border-top-table-container">
            <Table className="border-top-table">
                <TableHead>
                    <TableRow >
                        <TableCell>
                            <span className="border-top-table-header-text">
                                {t('configure_which_channels_to_use_for_each_event_type')}
                            </span>
                        </TableCell>
                        {columns.map((col) => (
                            <TableCell
                                key={col.key}
                                className="border-top-table-center"
                            >
                                <Box className="border-top-table-header-wrapper">
                                    {col.icon}
                                    <span className="border-top-table-header-text">{t(col.label)}</span>
                                </Box>
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {rows.map((row) => (
                        <TableRow key={row.id} >
                            <TableCell >
                                <span className="border-top-table-text">{t(row.label)}</span>
                            </TableCell>
                            {columns.map((col) => (
                                <TableCell
                                    key={col.key}
                                    className="border-top-table-center"
                                >
                                    <div className='d-flex justify-content-center align-items-center'>
                                        <CustomCheckbox
                                            id={`cb_${row.id}_${col.key}`}
                                            name={`${row.id}_${col.key}`}
                                            checked={!!row.values?.[col.key]}
                                            onChange={handleChange(row.id, col.key)}
                                            disabled={disabled}
                                        />
                                    </div>
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default BorderTopTable;
